import { useQuery } from '@apollo/client';
import { useMemo } from 'react';
import { gql } from '../graphql/generated/gql';

// eslint-disable-next-line slab-graphql/no-unused-colocated-fragments
const ALL_TOPIC_POSTS_QUERY = gql(`
  query allTopicsWithPosts {
    currentSession {
      organization {
        id
        topics {
          id
          allPosts(orderBy: TITLE, type: PUBLISHED) {
            edges {
              node {
                id
                publishedAt
                type
                ...PostTitleWithIcons_post
              }
              pinnedOrder
            }
          }
        }
      }
    }
  }
`);

const getAllTopicPosts = ({ data }) => {
  if (!data) {
    return null;
  }

  const { topics } = data.currentSession.organization;

  const map = {};
  topics.forEach(({ id, allPosts }) => {
    if (allPosts) {
      map[id] = allPosts.edges;
    }
  });

  return map;
};

const useAllTopicPostsFull = (options) => {
  const response = useQuery(ALL_TOPIC_POSTS_QUERY, {
    errorPolicy: 'ignore',
    ...options,
  });

  return useMemo(
    () => ({
      ...response,
      data: getAllTopicPosts(response),
    }),
    [response],
  );
};

export default useAllTopicPostsFull;
